<script>
  import resources from './resources'

  export default {
    name: 'config-advanced',

    mixins: [resources]
  }
</script>

<template lang="pug">
  page(title="Configurações Avançadas", icon="")
    .col-xs-12.content
      .container-fluid.zero-margin
        .row
          .col-xs-12.white-bg(style='margin-top:30px;')
            div.configuracoes-avancadas
              .col-xs-12.col-md-12
                h4 Modo de Integração
                .line
                  .text Offline
                  .switch(
                    @click.prevent="doToogleIntegrationSettings('offline')",
                    :class="{true: settings.notify.integration.offline, false: !settings.notify.integration.offline}"
                    )
                    .dot
                .line
                  .text API Própria
                  .switch(
                    @click.prevent="doToogleIntegrationSettings('ownApi')",
                    :class="{true: settings.notify.integration.ownApi, false: !settings.notify.integration.ownApi}"
                    )
                    .dot
                .line
                  .text API Medibook
                  .switch(
                    @click.prevent="doToogleIntegrationSettings('medibookApi')",
                    :class="{true: settings.notify.integration.medibookApi, false: !settings.notify.integration.medibookApi}"
                    )
                    .dot
                .divider
              .col-xs-12.col-md-12
                h4 Notificações
                .line
                  .text Agenda Diária
                  .switch(
                    @click.prevent="doToogleNotifySettings('weeklySchedule')",
                    :class="{true: settings.notify.weeklySchedule, false: !settings.notify.weeklySchedule}"
                    )
                    .dot
                .line
                  .text Resumo Semanal
                  .switch(
                    @click.prevent="doToogleNotifySettings('weeklySummary')",
                    :class="{true: settings.notify.weeklySummary, false: !settings.notify.weeklySummary}"
                    )
                    .dot
                .line
                  .text Estatísticas de Atendimento
                  .switch(
                    @click.prevent="doToogleNotifySettings('supportStatistics')",
                    :class="{true: settings.notify.supportStatistics, false: !settings.notify.supportStatistics}"
                    )
                    .dot
                .divider

                .subtitle Tipo de Notificações
                .line
                  .text E-mail
                  .switch(
                    @click.prevent="doToogleNotifySendSettings('email')",
                    :class="{true: settings.notify.send.email, false: !settings.notify.send.email}"
                    )
                    .dot
                .line
                  .text SMS
                  .switch(
                    @click.prevent="doToogleNotifySendSettings('sms')",
                    :class="{true: settings.notify.send.sms, false: !settings.notify.send.sms}"
                    )
                    .dot

                .line
                  .text
                    | App Mobile
                    small (Smartphones)
                  .switch(
                    @click.prevent="doToogleNotifyPushAppSettings()",
                    :class="{true: settings.notify.send.push.app, false: !settings.notify.send.push.app}"
                    )
                    .dot

                .line
                  .text
                    | App Web
                    small (Push Notifications)
                  .switch(
                    @click.prevent="doToogleNotifyPushWebSettings()",
                    :class="{true: settings.notify.send.push.web, false: !settings.notify.send.push.web}"
                    )
                    .dot
                .divider
              //- .col-xs-12.col-md-12
                .divider.hidden-md.hidden-lg
                h4 Alertar Dependentes
                .row
                  .col-md-10.col-xs-10
                     f-select-dependent(
                        name="dependents"
                        v-model="settings.notify.dependent",
                        :get-all="true",
                        @selected="doPushNotifyDependentsSettings",
                        :multiple="true",
                        :searchable="true")

                  .col-md-2
                    .line.select(style="margin-top: 15px;")
                      .switch(
                        @click.prevent="doToogleNotifyDependentsSettings()",
                        :class="{true: settings.notify.dependents, false: !settings.notify.dependents}"
                        )
                        .dot
</template>



// WEBPACK FOOTER //
// src/app/professional/config/index.vue